import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {UserThemeConsumer} from '../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {NavigationLineLabel} from '../../../common/navigation/navigationLineLabel';
import {NavigationLineStandardIcon} from '../../../common/navigation/navigationLineStandardIcon';
import {WorkspaceLineDropTarget} from '../line/workspaceLineDropTarget';

/*
 * Props.
 */

interface CreateLensButtonProps {
  onClick: Handler;
}

/*
 * Styles.
 */

const StyledCreateCtaDiv = styled.div`
  display: flex;
  align-items: center;
  color: ${(p) => p.theme.interactiveText};
  font-weight: ${fontWeights.medium};
`;

/*
 * Component.
 */

export const CreateLensButton: FC<CreateLensButtonProps> = ({onClick}) => (
  <UserThemeConsumer>
    {(theme) => (
      <WorkspaceLineDropTarget
        indentLevel={0}
        onClick={onClick}
        shouldAlphabetizeWorkspace={false}
        workspaceDragItem={undefined}
      >
        {<NavigationLineStandardIcon iconName="plusCircleSmall" color={theme.palette.blue.shade40} />}
        <NavigationLineLabel>
          <StyledCreateCtaDiv>
            <Trans id="lenses-workspace-create-lens">Create view</Trans>
          </StyledCreateCtaDiv>
        </NavigationLineLabel>
      </WorkspaceLineDropTarget>
    )}
  </UserThemeConsumer>
);
